export const memojiOptions = {
  gender: [
    { value: "male", label: "Male", preview: "👨" },
    { value: "female", label: "Female", preview: "👩" },
    { value: "non-binary", label: "Non-binary", preview: "🧑" }
  ],
  
  ageGroup: [
    { value: "young adult", label: "Young", preview: "🧒" },
    { value: "adult", label: "Adult", preview: "🧑" },
    { value: "middle-aged", label: "Mature", preview: "👨‍💼" },
    { value: "senior", label: "Senior", preview: "👴" }
  ],
  
  skinTone: [
    { value: "light", label: "Light", preview: "🤍" },
    { value: "medium-light", label: "Medium Light", preview: "🤎" },
    { value: "medium", label: "Medium", preview: "🤎" },
    { value: "medium-dark", label: "Medium Dark", preview: "🤎" },
    { value: "dark", label: "Dark", preview: "🖤" }
  ],
  
  hairStyle: [
    { value: "short", label: "Short", preview: "✂️" },
    { value: "medium", label: "Medium", preview: "💇‍♀️" },
    { value: "long", label: "Long", preview: "👱‍♀️" },
    { value: "curly", label: "Curly", preview: "🌀" },
    { value: "wavy", label: "Wavy", preview: "〰️" },
    { value: "straight", label: "Straight", preview: "📏" },
    { value: "buzz cut", label: "Buzz", preview: "🪒" },
    { value: "bald", label: "Bald", preview: "🥚" }
  ],
  
  hairColor: [
    { value: "black", label: "Black", preview: "⚫" },
    { value: "brown", label: "Brown", preview: "🤎" },
    { value: "blonde", label: "Blonde", preview: "🟡" },
    { value: "red", label: "Red", preview: "🔴" },
    { value: "gray", label: "Gray", preview: "⚪" },
    { value: "white", label: "White", preview: "⚪" }
  ],
  
  eyeColor: [
    { value: "brown", label: "Brown", preview: "🤎" },
    { value: "blue", label: "Blue", preview: "🔵" },
    { value: "green", label: "Green", preview: "🟢" },
    { value: "hazel", label: "Hazel", preview: "🟤" },
    { value: "gray", label: "Gray", preview: "⚪" }
  ],
  
  facialHair: [
    { value: "none", label: "None", preview: "😊" },
    { value: "mustache", label: "Mustache", preview: "🥸" },
    { value: "beard", label: "Full Beard", preview: "🧔‍♂️" },
    { value: "goatee", label: "Goatee", preview: "🧔" },
    { value: "stubble", label: "Stubble", preview: "👨‍🦲" }
  ],
  
  glasses: [
    { value: "none", label: "None", preview: "👁️" },
    { value: "prescription glasses", label: "Glasses", preview: "👓" },
    { value: "sunglasses", label: "Sunglasses", preview: "🕶️" },
    { value: "reading glasses", label: "Reading", preview: "🤓" }
  ],
  
  expression: [
    { value: "smiling", label: "Smiling", preview: "😊" },
    { value: "neutral", label: "Neutral", preview: "😐" },
    { value: "happy", label: "Happy", preview: "😄" },
    { value: "confident", label: "Confident", preview: "😎" },
    { value: "friendly", label: "Friendly", preview: "😌" }
  ]
};